import { render, staticRenderFns } from "./BoardSkeleton.vue?vue&type=template&id=0951e5b7&scoped=true&"
import script from "./BoardSkeleton.vue?vue&type=script&lang=js&"
export * from "./BoardSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./BoardSkeleton.vue?vue&type=style&index=0&id=0951e5b7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0951e5b7",
  null
  
)

export default component.exports